/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const PRIVACY_POLICY_STATE_KEY = 'privacyPolicy';
export const PRIVACY_POLICY_SESSION_KEY = 'privacyPolicyUpdateSession';
export const PRIVACY_POLICY_MODAL_CONTENT = 'PrivacyPolicyModal_Content';
export const COOKIE_MARKETING_TRACKING_CONSENT = 'MarketingTrackingConsent';
export const COOKIE_PRIVACY_NOTICE_VERSION = 'PrivacyNoticeVersion';
export const MARKETING_TRACKING_CONSENT_KEY = 'marketingTrackingConsent';
export const PRIVACY_NOTICE_VERSION_KEY = 'privacyNoticeVersion';

export const COOKIE_GDPR_MANAGEMENT = [
	COOKIE_PRIVACY_NOTICE_VERSION,
	COOKIE_MARKETING_TRACKING_CONSENT,
];
